import { render, staticRenderFns } from "./records.vue?vue&type=template&id=3992dcdc&scoped=true"
import script from "./records.vue?vue&type=script&lang=ts"
export * from "./records.vue?vue&type=script&lang=ts"
import style0 from "./records.vue?vue&type=style&index=0&id=3992dcdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992dcdc",
  null
  
)

export default component.exports